import React, { useContext } from 'react';
import { ThemeContext } from '../theme';

/**
 * Reusable toggle switch matching the Taleo design system.
 *
 * Props:
 *   checked  — boolean
 *   onChange — (newValue: boolean) => void
 *   scale    — uniform size multiplier (default 1)
 */
export default function ToggleSwitch({ checked, onChange, scale = 1, checkedColor }) {
  const theme = useContext(ThemeContext);
  const resolvedCheckedColor = checkedColor ?? theme.toggleOnBg;
  const s = (n) => Math.round(n * scale);

  const trackW  = s(52);
  const trackH  = s(28);
  const thumbSz = s(22);
  const thumbOff = s(3);
  const travelX = trackW - thumbSz - thumbOff * 2;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      style={{
        position: 'relative',
        width: trackW,
        height: trackH,
        borderRadius: trackH,
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        backgroundColor: checked ? resolvedCheckedColor : theme.toggleOffBg,
        transition: 'background-color 0.2s',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: thumbOff,
          left: thumbOff,
          width: thumbSz,
          height: thumbSz,
          borderRadius: '50%',
          backgroundColor: '#FFFFFF',
          transform: checked ? `translateX(${travelX}px)` : 'translateX(0)',
          transition: 'transform 0.2s',
        }}
      />
    </button>
  );
}
